/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import WiperBladeNotificationStyles from './WiperBladeNotificationStyles.module.scss';
import { useLabels } from '@/hooks/useLabels';
import { View } from '@az/starc-ui';
import { Icon } from '@az/starc-ui';
import { InfoCircle } from '@az/starc-ui-icons';

const labelMap = {
  WiperBladeNotification: 'label_PDP_WiperBladeNotification',
};

export const WiperBladeNotification = () => {
  const labels = useLabels(labelMap);
  return (
    <View className={WiperBladeNotificationStyles.container}>
      <View className={WiperBladeNotificationStyles.image}>
        <Icon svg={InfoCircle} size={4} attributes={{ style: { color: '#015FCC' } }} />
      </View>
      <View className={WiperBladeNotificationStyles.text}>{labels.WiperBladeNotification}</View>
    </View>
  );
};
